// ======================================================================
// File Name       : SuperUserRegisterUpdate
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, Button, Table } from 'react-bootstrap';
import SelectBox from '../SelectBox';
import { getItemBoxName } from '../../utils/index';
import { MODE, VALIDATE_TYPE, LOCK_TYPE } from '../../constants/index';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import FormControlValidate from '../FormControlValidate';
import FormControlPassword from '../FormControlPassword';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { getEnterprisePath } from '../../utils/EnterPriseUtils';
import { createEnterpriseRoleDataOptions, createServiceRoleDataOptions } from '../../utils/SuperUserUtils';
import { KEY_ROLE_TYPE } from '../../constants/SuperUserContants';
import { USER_AUTHORITY_ROLE } from '../../constants/AuthorityConstant';

class SuperUserRegisterUpdate extends React.Component {
  constructor() {
    super();
    this.validation = this.validation.bind(this);
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      (ref) => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation()
    );
  }

  render() {
    const {
      superuserDetail,
      enterpriseList,
      mode,
      handleChange,
      showEnterpriseDialog,
      showCheckDlg,
      allServiceRelation,
      allServiceCdRoleList,
      roleBatchValue,
      superuserAllServiceRoleList,
      enterpriseCd,
      superuserAllEnterpriseRoleList,
      superuserEnterpriseRoleSecernId,
      serviceCdListSorted,
      loginIdPasswordSendFlag,
      // Step 10.2.0 START
      loginSuperuserEnterpriseRoleSecernId,
      loginSuperuserServiceRoleList,
      isSuperUserL0,
      // Step 10.2.0 END
    } = this.props;
    this.refsToValidate = [];
    const requiredClass = mode === MODE.NEW_MODE && <span className="required">&nbsp;(※)</span>;
    if (superuserDetail.isUnlock === undefined) {
      superuserDetail.isUnlock = superuserDetail.lockState ? 0 : 1;
    }

    const roleData =
      superuserAllServiceRoleList &&
      Object.keys(superuserAllServiceRoleList.roleList).length > 0 &&
      createServiceRoleDataOptions(superuserAllServiceRoleList.roleList);

    const enterpriseRoleData =
      superuserAllEnterpriseRoleList &&
      Object.keys(superuserAllEnterpriseRoleList).length > 0 &&
      createEnterpriseRoleDataOptions(superuserAllEnterpriseRoleList.roleList);

    let isShowRoleList = false;
    if (allServiceRelation &&
      Object.keys(allServiceRelation).length > 0) {
      isShowRoleList =
        mode === MODE.NEW_MODE
          ? enterpriseCd !== undefined
          : superuserAllServiceRoleList && Object.keys(superuserAllServiceRoleList).length > 0;
    }

    const serviceRoleList =
    allServiceRelation && Object.keys(allServiceRelation).length > 0 &&
      serviceCdListSorted.map((cur, index) => {
        const { serviceCd, serviceName } = allServiceRelation[cur];
        const roleValue = allServiceCdRoleList ? allServiceCdRoleList && allServiceCdRoleList[cur] : '';
        // Step 10.2.0 START
        const isDisabled =
          superuserDetail.rootFlag ||
          (!isSuperUserL0 &&
            loginSuperuserServiceRoleList[serviceCd] &&
            loginSuperuserServiceRoleList[serviceCd].superuserServiceRoleSecernId !== USER_AUTHORITY_ROLE.ADMIN);
        // Step 10.2.0 END
        return (
          <Col sm={12} key={index} className="padding-left-right-clear">
            <Col sm={4} as={Form.Label} className="padding-left-50 margin-top-10">
              {serviceName}
            </Col>
            <Col sm={8} as={Form.Label}>
              <Col sm={4} className="padding-left-right-clear">
                <SelectBox
                  data={roleData}
                  name={`${KEY_ROLE_TYPE.ROLE_OPTIONS}.${serviceCd}`}
                  value={roleValue}
                  onChange={handleChange}
                  disabled={isDisabled} // Step 10.2.0
                />
              </Col>
              <Col sm={4} className="role-setting-link">
                <a onClick={() => this.props.openAuthorityAboutDialog(roleValue)}>
                  <u className="cursor_pointer">ロール設定確認</u>
                </a>
              </Col>
            </Col>
          </Col>
        );
      });

    return (
      <Col className="padding-left-15 padding-right-15">
        <Form onSubmit={(e) => { e.preventDefault(); showCheckDlg();}} className='form-horizontal'>
          <Form.Group className="form-info" controlId="formHorizontalSuperUserName">
            <Col as={Form.Label} sm={4}>
              SuperUser名<span className="required">&nbsp; (※)</span>
            </Col>
            <Col sm={8}>
              <FormControlValidate
                type="text"
                maxLength="40"
                required
                label="SuperUser名"
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                name="superuserName"
                onChange={handleChange}
                value={superuserDetail.superuserName}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info" controlId="formHorizontalLoginID">
            <Col as={Form.Label} sm={4}>
              ログインID <span className="required">&nbsp;(※)</span>
            </Col>
            <Col sm={8}>
              <FormControlValidate
                  type="text"
                  label="ログインID"
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  name="loginId"
                  required
                  maxLength="256"
                  value={superuserDetail.loginId}
                  // Step 10.1.0 START
                  // Step 11.0.0 START
                  validateType={VALIDATE_TYPE.LOGIN_ID_SU}
                  // Step 11.0.0 END
                  // Step 10.1.0 END
                  onChange={handleChange}
                  messageError={MessageTemplate.MSG_ID_INVALID}
                  messageSuccess={MessageTemplate.MSG_ID_VALID}
                />
            </Col>
          </Form.Group>
          <FormControlPassword
            onChange={handleChange}
            value={superuserDetail.password}
            required={mode === MODE.NEW_MODE}
            labelSize={4}
            inputSize={8}
            label="パスワード"
            ref={(ref) => {
              if (ref) {
                this.refsToValidate.push(ref);
              }
            }}
            name="password"
            loginID={superuserDetail.loginId}
            type={VALIDATE_TYPE.PASSWORD}
            showAbout
            isStrongPasswordOnly
          />
          <FormControlPassword
            labelSize={4}
            inputSize={8}
            label="パスワード (確認)"
            ref={(ref) => {
              if (ref) {
                this.refsToValidate.push(ref);
              }
            }}
            name="passwordconfirm"
            required={mode === MODE.NEW_MODE || superuserDetail.password || false}
            passwordConfirm={superuserDetail.password}
            type={VALIDATE_TYPE.PASSWORD_CONFIRM}
          />
          {/* Step 10.0.0 START */}
          {enterpriseRoleData && (
            <Form.Group className="form-info">
              <Col sm={4} as={Form.Label} className="padding-left-right-clear">
                企業ロール<span className="required">&nbsp; (※)</span>
              </Col>
              <Col sm={8}>
                <Col sm={4} className="padding-left-right-clear">
                  <SelectBox
                    data={enterpriseRoleData}
                    name="superuserEnterpriseRoleSecernId"
                    value={superuserDetail.superuserEnterpriseRoleSecernId || ''}
                    onChange={handleChange}
                    disabled={
                      superuserDetail.rootFlag ||
                      (!isSuperUserL0 && loginSuperuserEnterpriseRoleSecernId !== USER_AUTHORITY_ROLE.ADMIN)
                    }
                  />
                </Col>
                <Col sm={4} className="role-setting-link">
                  <a onClick={() => this.props.openEnterpriseAuthorityAboutDialog(superuserDetail.superuserEnterpriseRoleSecernId)}>
                    <u className="cursor_pointer">ロール設定確認</u>
                  </a>
                </Col>
              </Col>
            </Form.Group>
          )}

          {isShowRoleList && roleData && (
            <Form.Group className="form-info">
              <Col sm={4} className="padding-left-right-clear">
                <Col sm={8} as={Form.Label}>
                  サービスロール<span className="required">&nbsp; (※)</span>
                </Col>
                <Col sm={4} as={Form.Label} className="text-right">
                  一括設定変更
                </Col>
              </Col>
              <Col sm={8}>
                <Col sm={4} className="padding-left-right-clear">
                  <SelectBox
                    data={roleData}
                    addingEmptyOption
                    name={KEY_ROLE_TYPE.BATCH_ROLE_OPTIONS}
                    value={roleBatchValue}
                    onChange={handleChange}
                    disabled={superuserDetail.rootFlag}
                  />
                </Col>
              </Col>
              <Col sm={12} className="margin-top-10 padding-left-right-clear">
                {serviceRoleList}
              </Col>
            </Form.Group>
          )}
          {/* Step 10.0.0 END */}
          <Form.Group className="form-info" controlId="formHorizontalEMail">
            <Col as={Form.Label} sm={4}>
              メールアドレス
            </Col>
            <Col sm={8}>
              <FormControlValidate
                type="text"
                label="メールアドレス"
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                name="mailAddress"
                value={superuserDetail.mailAddress}
                validateType={VALIDATE_TYPE.EMAIL}
                onChange={handleChange}
                messageError={MessageTemplate.MSG_EMAIL_INVALID}
                messageSuccess={MessageTemplate.MSG_EMAIL_VALID}
                required={loginIdPasswordSendFlag}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info label-middle" controlId="formHorizontalReMark">
            <Col as={Form.Label} sm={4}>
              備考
            </Col>
            <Col sm={8}>
              <FormControl
                as="textarea"
                maxLength="256"
                name="remark"
                onChange={handleChange}
                className="textarea"
                rows={3}
                value={superuserDetail.remark}
              />
            </Col>
          </Form.Group>
          {mode === MODE.EDIT_MODE &&
            <Form.Group className="form-info" controlId="formHorizontalStatus">
              <Col as={Form.Label} sm={4}>
                ロック状態
              </Col>
              <Col as={Form.Label} sm={8}>
                {getItemBoxName(LOCK_TYPE, superuserDetail.lockState)}
              </Col>
              { superuserDetail.lockState === 1 &&
              <Col
                as={Form.Label}
                sm={{
                  span: 3,
                  offset: 4
                }}>
                <Form.Check
                  type='checkbox'
                  name="isUnlock"
                  id="isUnlock"
                  checked={superuserDetail.isUnlock}
                  onChange={handleChange}
                  label='ロックを解除する'></Form.Check>
              </Col>}
            </Form.Group>}
          <Form.Group className="form-info">
            <Col sm={5}>
              <Form.Check
                type='checkbox'
                name="passwordChangeFlag"
                id="passwordChangeFlag"
                checked={superuserDetail.passwordChangeFlag}
                onChange={handleChange}
                label='次回ログイン時にパスワード変更'></Form.Check>
            </Col>
          </Form.Group>
          {/* sprint_20230418 #12 START */}
          <Form.Group className="form-info">
            <Col sm={5}>
              <Form.Check
                type='checkbox'
                name="readOnlyFlag"
                id="readOnlyFlag"
                checked={superuserDetail.readOnlyFlag}
                onChange={handleChange}
                label='読み取り専用'></Form.Check>
            </Col>
          </Form.Group>
          {/* sprint_20230418 #12 END */}
          <input type="submit" hidden="true" />
          {/* Step 10.1.0 START */}
          <Form.Group className="form-info">
            <Col sm={5}>
              <Form.Check
                type='checkbox'
                name="loginIdPasswordSendFlag"
                id="loginIdPasswordSendFlag"
                onChange={handleChange}
                label='ログインID、パスワードをメールで送信する'></Form.Check>
              <span className="required padding-left-20" hidden={!loginIdPasswordSendFlag}>
                メール送信のために、メールアドレスを入力してください。
              </span>
            </Col>
          </Form.Group>
          {/* Step 10.1.0 END */}
        </Form>
      </Col>
    );
  }
}

export default SuperUserRegisterUpdate;
